import { ron } from "@/lib/bf";

const KINDS = [["dye", "Vopsea", 60, "60 ml"], ["shampoo", "Șampon", 1, "ml"], ["powder", "Pudră decolorantă", 1, "gram"], ["mask", "Mască", 1, "gram"]];

const fmt = (v) => (v < 1 ? `${v.toFixed(3).replace(".", ",")} lei` : ron(v));
const per = (ok, k, field, mult) => {
  const xs = ok.filter((x) => x.kind === k && x.amt > 0 && x[field] > 0);
  const amt = xs.reduce((s, x) => s + x.amt * x.q, 0);
  return amt ? (xs.reduce((s, x) => s + x[field] * x.q, 0) / amt) * mult : 0;
};

const Col = ({ ok, field, title, testid }) => {
  const total = ok.reduce((s, x) => s + (x[field] ?? x.unit) * x.q, 0);
  return (
    <div className="bf-fo-col" data-testid={testid}>
      <span>{title}</span>
      <b>{ron(total)}</b>
      {KINDS.map(([k, label, mult, unit]) => {
        const v = per(ok, k, field, mult);
        return v > 0 && <small key={k} data-testid={`${testid}-${k}`}>{label}: <em>{fmt(v)}</em> / {unit}</small>;
      })}
    </div>
  );
};

export default function BFFreeTotals({ ok }) {
  if (!ok.length) return null;
  const full = ok.reduce((s, x) => s + (x.list ?? x.unit) * x.q, 0);
  const bf = ok.reduce((s, x) => s + x.unit * x.q, 0);
  return (
    <div className="bf-fo-totals" data-testid="bf-fo-totals">
      <Col ok={ok} field="unit" title="Total cu discount" testid="bf-fo-tot-bf" />
      <Col ok={ok} field="list" title="Total fără discount (preț listă salon)" testid="bf-fo-tot-list" />
      {full > bf && <p className="bf-fo-saving" data-testid="bf-fo-saving">Salonul economisește {ron(full - bf)} ({Math.round(((full - bf) / full) * 100)}%)</p>}
    </div>
  );
}
